(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .service('dashboardResource', dashboardResource);

  dashboardResource.$inject = ['$http', 'ServiceHelper'];

  function dashboardResource($http, ServiceHelper) {
    var url = {
      trainees: 'https://:host/:ipad/gaviota-api/trainee-cModule',
      dashboard: 'https://:host/:ipad/mm/cs/trainee-dash',
      action: 'https://:host/:ipad/gaviota-api/trainee/cModule/:cModuleId/:action',
      catalog: 'https://:host/:ipad/gaviota-api/trainee-catalog',
      cModule: 'https://:host/:ipad/gaviota-api/cModule/:cModuleId/:action',
      course: 'https://:host/:ipad/gaviota-api/course/:courseId/:action',
      courseTrainee: 'https://:host/:ipad/mm/cs/trainee/course/:courseId/:action',
      cModuleTrainee: 'https://:host/:ipad/mm/cs/trainee/cModule/:cModuleId/:action',
      courseModuleTrainee: 'https://:host/:ipad/mm/cs/trainee/course/:courseId/cModule/:cModuleId/:action',
      session: 'https://:host/:ipad/gaviota-api/session',
      user: 'https://:host/:ipad/gaviota-api/user/:userId',
      account: 'https://:host/:ipad/mm/account/associatedAccounts',
      switch: 'https://:host/:ipad/mm/account/getSwitchUrl',
      userApp: 'https://:host/:ipad/mm/user/manageusers/user-app-info',
    };

    var keys = ['ipad', 'cModuleId', 'action', 'userId'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function (url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function (url, key) {
        var value = data[key];
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function (response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function (response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    this.getAssociatedAccounts = function getAssociatedAccounts(resultCb, errorCb) {
      return respond($http.get(createUrl(url.account, ServiceHelper.defaultUrlParams())), resultCb, errorCb);
    };

    this.capitalize = function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    this.switchAccounts = function switchAccounts(params, resultCb, errorCb) {
      return respond($http.get(createUrl(url.switch, ServiceHelper.defaultUrlParams()), params),
        resultCb, errorCb);
    };

    this.getTraineeDashboardInfoMM = function getTraineeDashboardInfoMM(resultCb, errorCb) {
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.get(createUrl(url.dashboard, ServiceHelper.defaultUrlParams())),
          resultCb, errorCb);
      });
    };

    this.retake = function retake(courseId, id, resultCb, errorCb) {
      var urlParams = _.extend({ courseId: courseId, action: 'retake' }, ServiceHelper.defaultUrlParams());
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.put(createUrl(url.courseTrainee, urlParams)), resultCb, errorCb);
      });
    };

    this.retakeMM = function retake(cModuleId, courseId, resultCb, errorCb) {
      var urlParams = _.extend({ cModuleId: cModuleId, action: 'retake' }, ServiceHelper.defaultUrlParams());
      return ServiceHelper.checkCanCallService(function () {
        if (courseId) {
          urlParams.courseId = courseId;
          return respond($http.post(createUrl(url.courseModuleTrainee, urlParams), null), resultCb, errorCb);
        }
        return respond($http.post(createUrl(url.cModuleTrainee, urlParams), null), resultCb, errorCb);
      });
    };

    this.drop = function drop(courseId, resultCb, errorCb) {
      var urlParams = _.extend({ courseId: courseId, action: 'drop' }, ServiceHelper.defaultUrlParams());
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.put(createUrl(url.courseTrainee, urlParams)), resultCb, errorCb);
      });
    };

    this.getCatalogInfo = function getCatalogInfo(catalogIds, resultCb, errorCb) {
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.post(createUrl(url.catalog, ServiceHelper.defaultUrlParams()), {
          catalogIds: catalogIds
        }), resultCb, errorCb);
      });
    };

    this.getAccountInfo = function getAccountInfo(resultCb, errorCb) {
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.post(createUrl(url.session, ServiceHelper.defaultUrlParams()), {}),
          resultCb, errorCb);
      });
    };

    this.updateUserInfo = function updateUserInfo(userId, info, resultCb, errorCb) {
      var urlParams = _.extend({ userId: userId }, ServiceHelper.defaultUrlParams());
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.post(createUrl(url.user, urlParams), info), resultCb, errorCb);
      });
    };

    this.enrollTraineeToCourse = function enrollTraineeToCourse(courseId, clientDatestamp, resultCb, errorCb) {
      var urlParams = _.extend({ courseId: courseId, action: 'enroll' }, ServiceHelper.defaultUrlParams());
      return ServiceHelper.checkCanCallService(function () {
        return respond($http.post(createUrl(url.course, urlParams), {
          clientDatestamp: clientDatestamp
        }), resultCb, errorCb);
      });
    };

    this.getUserAppInfo = function getUserAppInfo() {
      return new Promise(function (resolve, reject) {
        ServiceHelper.checkCanCallService(function () {
          $http.get(createUrl(url.userApp, ServiceHelper.defaultUrlParams())).then(function (response) {
            resolve(response.data);
          }).catch(reject);
        });
      });
    };
  }

})();
